import { useSelector } from 'react-redux';
import { RootState } from '../store/state';

export const useAdminSettingsState = () =>
    useSelector<RootState, RootState['adminSettings']>(state => state.adminSettings);
